/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Image, Button, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { UltyMoney } from '@ulty/ulty-ui'
import { NotificationTypeHeader } from './NotificationTypeHeader'

const OrderNotification = ({order, type, onNavigateToOrder, onAcceptOrder, user}) => {
    const [t] = useTranslation()

    return (
      <div css={css`
          display: flex;
          flex-direction: column;
          min-width: 250px;
          overflow: hidden;
      `}>
          <NotificationTypeHeader type={type}/>

          <div css={css`
              display: flex;
              flex-direction: row;
              width: 100%;
              padding: 12px;
              align-items: flex-start;
          `}>
              <div css={css`
                  display: flex;
                  align-items: center;
              `}>
                  <Image size="tiny" src={order.platform.logo}/>
              </div>

              <div css={css`
                  padding-left: 10px;
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  gap: 4px;
              `}>
                  <div css={css`
                      font-weight: bold;
                      font-size: 15px;
                  `}>
                      {`${order.displayId.indexOf('#') !== -1 ? '' : '# '}${order.displayId}`}
                  </div>

                  <div css={css`
                      display: flex;
                      align-items: center;
                      gap: 8px;
                      font-size: 13px;
                      color: #666;
                  `}>
                      {order.price && (
                        <UltyMoney
                          readonly
                          amount={order.price}
                          currencyCode={user.getCompanyCurrency()}
                          locale={user.getCompanyLocale()}
                        />
                      )}
                      {order.nbProducts && (
                        <span>
                            {t('order.num_products', {count: order.nbProducts})}
                          </span>
                      )}
                  </div>

                  {order.orderType && (
                    <span css={css`
                        display: flex;
                        gap: 8px;
                        font-size: 13px;
                        color: #666;
                    `}>
                {t(`order.type_${order.orderType}`)}
            </span>
                  )}
              </div>
          </div>
          <div css={css`
              display: flex;
              column-gap: .5rem;
          `}>
              {(onAcceptOrder && order.status === 'RECEIVED') && (
                <Button
                  css={css`
                      flex: 1;
                      &.ui.button {
                        border-radius: 0;
                      }
                  `}
                  color="green"
                  onClick={onAcceptOrder}>{t('order.accept')}
                </Button>
              )}

              {type === 'NEW' && (
                <Button
                  css={css`
                      flex: 1;

                      &.ui.button {
                          margin: 0;
                          border-radius: 0 0 4px ${onAcceptOrder ? '0' : '4px'};
                      }
                  `}
                  as={Link}
                  to={`/orders/${order.id}`}
                  color='teal'
                  onClick={onNavigateToOrder}>{t('order.notification.handle')}
                    <Icon
                      name="right chevron"
                    />
                </Button>
              )}

              {type === 'CANCELLED' && (
                <Button
                  css={css`
                      flex: 1;
                      &.ui.button {
                          margin: 0;
                          border-radius: 0 0 4px 4px;
                      }
                  `}
                  basic
                  color="teal"
                  as={Link}
                  to={`/orders/${order.id}`}
                  onClick={onNavigateToOrder}>{t('global.see')}
                    <Icon
                      name="right chevron"
                    />
                </Button>
              )}
          </div>
      </div>
    )
}

export { OrderNotification }
